import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import React from 'react';
import ReactDOM from 'react-dom';

import { settings } from '../config/settings';
import { theme } from '../config/theme';
import { BrowserRouter } from 'react-router-dom';
import { CoreProvider } from '../../../shared/providers';

/**
 * Initialize default Firebase instance that we will be using in the
 * application.
 */
firebase.initializeApp(settings.firebase[settings.env]);

ReactDOM.render(
    <BrowserRouter>
        <CoreProvider settings={settings} theme={theme}></CoreProvider>
    </BrowserRouter>,
    document.getElementById('app'),
);
